import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
  templateUrl: './total-template.component.html',
  styleUrls: ['./total-template.component.scss']
})
export class TotalTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  @ViewChild('template', { static: true })
  template: TemplateRef<any>;

  isPlural(total: number, path: string): string {
    return total > 1 ? `${path}s` : path;
  }
}
